import { render, staticRenderFns } from "./tvr_staff.vue?vue&type=template&id=6157707e&scoped=true"
import script from "./tvr_staff.vue?vue&type=script&lang=js"
export * from "./tvr_staff.vue?vue&type=script&lang=js"
import style0 from "./tvr_staff.vue?vue&type=style&index=0&id=6157707e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6157707e",
  null
  
)

export default component.exports